import { retrieveRawInitData } from '@tma.js/sdk';
import type {
  PrefsRequestBody,
  PrefsResponseBody,
  PrefsGetResponseBody,
  ReminderPrefs,
} from '@sayfazkari/shared';

/**
 * URL воркера бота — задаётся при сборке (Cloudflare Pages → Environment
 * Variables → VITE_BOT_URL). Пусто в dev, если бот ещё не развёрнут:
 * тогда сохранение напоминаний в настройках просто недоступно.
 */
const BOT_URL = import.meta.env.VITE_BOT_URL as string | undefined;

export function isReminderApiAvailable(): boolean {
  return Boolean(BOT_URL);
}

export async function saveReminderPrefs(prefs: ReminderPrefs): Promise<void> {
  if (!BOT_URL) throw new Error('VITE_BOT_URL не задан');

  const initData = retrieveRawInitData();
  if (!initData) throw new Error('initData недоступна вне Telegram');

  const body: PrefsRequestBody = { initData, prefs };

  const res = await fetch(`${BOT_URL}/prefs`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });

  const data = (await res.json()) as PrefsResponseBody;
  if (!res.ok || !data.ok) {
    throw new Error(data.error ?? `HTTP ${res.status}`);
  }
}

/**
 * Читает настройки с сервера. Источник правды — база бота: именно
 * оттуда уходят напоминания. Локальная копия нужна лишь для того,
 * чтобы поле было заполнено сразу, не дожидаясь сети.
 *
 * initData уходит заголовком, а не в query-строке: внутри неё данные
 * пользователя, и в URL они осели бы в логах.
 */
export async function loadReminderPrefs(): Promise<ReminderPrefs | null> {
  if (!BOT_URL) throw new Error('VITE_BOT_URL не задан');

  const initData = retrieveRawInitData();
  if (!initData) throw new Error('initData недоступна вне Telegram');

  const res = await fetch(`${BOT_URL}/prefs`, {
    headers: { Authorization: `tma ${initData}` },
  });

  const data = (await res.json()) as PrefsGetResponseBody;
  if (!res.ok || !data.ok) throw new Error(data.error ?? `HTTP ${res.status}`);
  return data.prefs ?? null;
}
